export const isDevelopment =
  process.env.NEXT_PUBLIC_ENV === 'development' ||
  process.env.NEXT_PUBLIC_ENV === 'local';
